export default __webpack_public_path__ + "static/media/YAS0930.34I-42408_-25408_0.aa2af4fa.jpg";